import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f5b77c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subheader col-6" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "subheader-title" }, "勤怠管理個別")
], -1))
const _hoisted_4 = { class: "subheader-block ml-auto demo" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1))
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1))
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-xl-12" }
const _hoisted_11 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "勤怠集計"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_13 = {
  class: "panel-container show",
  id: "panel-editers"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_15 = { class: "panel-content contents" }
const _hoisted_16 = { class: "demo" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-3 contCnt input-daterange input-group p-0 mb-2 mr-md-5" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "col-md-3 contCnt input-daterange input-group p-0" }
const _hoisted_22 = { class: "row workTotal" }
const _hoisted_23 = {
  class: "table-bordered",
  style: {"margin":"0px","height":"fit-content"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "5",
      class: "headWork cWT_1 fs-lg"
    }, "実務")
  ])
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "headWork cWT_2" }, "出勤日数"),
  /*#__PURE__*/_createElementVNode("th", { class: "headWork cWT_2" }, "時間内労働時間"),
  /*#__PURE__*/_createElementVNode("th", { class: "headWork cWT_2" }, "時間外労働時間"),
  /*#__PURE__*/_createElementVNode("th", { class: "headWork cWT_2" }, "労働時間計")
], -1))
const _hoisted_26 = { class: "cWT_3" }
const _hoisted_27 = { class: "cWT_3" }
const _hoisted_28 = { class: "cWT_3" }
const _hoisted_29 = { class: "cWT_3" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-xl-12" }
const _hoisted_32 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "出勤表"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_34 = {
  class: "panel-container show",
  id: "panel-editers4det"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_36 = { class: "panel-content contents" }
const _hoisted_37 = {
  key: 0,
  class: "col-md-12 contTitle",
  style: {"color":"#be2d2d"}
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon-stack icon-stack-lg",
  style: {"font-size":"21px"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-info-circle" })
], -1))
const _hoisted_39 = { class: "demo" }
const _hoisted_40 = { class: "row ditTableFrame" }
const _hoisted_41 = {
  id: "attendanceTable",
  class: "table-bordered",
  style: {"margin":"0px","width":"100%","height":"fit-content"}
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", {
    rowspan: "2",
    class: "fixhead headWork cwW_1"
  }, "日付"),
  /*#__PURE__*/_createElementVNode("th", {
    rowspan: "2",
    class: "fixhead headWork cwW_3"
  }, " ステータス "),
  /*#__PURE__*/_createElementVNode("th", {
    rowspan: "2",
    class: "fixhead headWork cwW_2"
  }, " 出勤時刻 "),
  /*#__PURE__*/_createElementVNode("th", {
    rowspan: "2",
    class: "fixhead headWork cwW_2"
  }, " 外出時刻 "),
  /*#__PURE__*/_createElementVNode("th", {
    rowspan: "2",
    class: "fixhead headWork cwW_2"
  }, " 戻り時刻 "),
  /*#__PURE__*/_createElementVNode("th", {
    rowspan: "2",
    class: "fixhead headWork cwW_2"
  }, " 退勤時刻 "),
  /*#__PURE__*/_createElementVNode("th", { class: "fixhead headWork cwW_3" }, "平日時間外"),
  /*#__PURE__*/_createElementVNode("th", { class: "fixhead headWork cwW_3" }, "平日深夜"),
  /*#__PURE__*/_createElementVNode("th", { class: "fixhead headWork cwW_3" }, "休日時間外"),
  /*#__PURE__*/_createElementVNode("th", { class: "fixhead headWork cwW_3" }, "休日深夜"),
  /*#__PURE__*/_createElementVNode("th", { class: "fixhead headWork cwW_3" }, "法定外時間外"),
  /*#__PURE__*/_createElementVNode("th", { class: "fixhead headWork cwW_3" }, "法定外深夜"),
  /*#__PURE__*/_createElementVNode("th", {
    rowspan: "2",
    class: "fixhead headWork cwW_4"
  }, "備考")
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "fixhead headWork cwW_3" }, "18時半～22時"),
  /*#__PURE__*/_createElementVNode("th", { class: "fixhead headWork cwW_3" }, "22時～5時"),
  /*#__PURE__*/_createElementVNode("th", { class: "fixhead headWork cwW_3" }, "6時～22時"),
  /*#__PURE__*/_createElementVNode("th", { class: "fixhead headWork cwW_3" }, "22時～5時"),
  /*#__PURE__*/_createElementVNode("th", { class: "fixhead headWork cwW_3" }, "6時～22時"),
  /*#__PURE__*/_createElementVNode("th", { class: "fixhead headWork cwW_3" }, "22時～5時")
], -1))
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1))
const _hoisted_46 = { class: "text-success fw-500" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mo_tableAttendance_row = _resolveComponent("Mo_tableAttendance_row")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!
  const _component_Or_map = _resolveComponent("Or_map")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-info waves-effect waves-themed",
              disabled: _ctx.btnDisable,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.upd()))
            }, [
              _hoisted_6,
              _createTextVNode("保存 ")
            ], 8, _hoisted_5))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-success waves-effect waves-themed",
          disabled: _ctx.btnDisable,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dl()))
        }, [
          _hoisted_8,
          _createTextVNode("Excel出力 ")
        ], 8, _hoisted_7)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      type: "month",
                      id: "month",
                      class: "form-control form-control-sm",
                      style: {"width":"60%"},
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.domDateMonth) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.domDateMonth]
                    ]),
                    _createElementVNode("input", {
                      type: "button",
                      class: "btn-primary form-control form-control-sm",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.prevMonth())),
                      disabled: _ctx.btnDisable,
                      value: "<<"
                    }, null, 8, _hoisted_19),
                    _createElementVNode("input", {
                      type: "button",
                      class: "btn-primary form-control form-control-sm",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.nextMonth())),
                      disabled: _ctx.btnDisable,
                      value: ">>"
                    }, null, 8, _hoisted_20)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    (!_ctx.isNuryokusya)
                      ? (_openBlock(), _createBlock(_component_vSelect, {
                          key: 0,
                          style: {"min-width":"150px"},
                          class: "staff-select",
                          options: _ctx.delegate4list.items4AttendanceStaffs,
                          modelValue: _ctx.domSelectStaff,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.domSelectStaff) = $event)),
                          label: "c_staff_name",
                          reduce: (label) => label.c_staff_id
                        }, null, 8, ["options", "modelValue", "reduce"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("table", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("tbody", null, [
                      _hoisted_25,
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.infoData.countDate4Work_3), 1),
                        _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.infoData.countTime4Ot_4), 1),
                        _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.infoData.countTime4SpOt_5), 1),
                        _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.infoData.countTime4Inner_6), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              (_ctx.isTooLong4all)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _hoisted_38,
                    _createTextVNode(" 背景が赤くなっている日付は、前日の退勤時間と、当日の出勤時間が10時間以内になっている日付です。ご注意ください。 ")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("table", _hoisted_41, [
                    _createElementVNode("thead", {
                      id: "tableHeader",
                      class: _normalizeClass(["bg-primary-400", { headerSticky: _ctx.isFollow }])
                    }, _hoisted_44, 2),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delegate.items4Attendance, (item) => {
                        return (_openBlock(), _createBlock(_component_Mo_tableAttendance_row, {
                          key: item.c_attendance_date,
                          item: item,
                          isDisable: !_ctx.isAdmin,
                          onEvShowMap: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showMap($event)))
                        }, null, 8, ["item", "isDisable"]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, {
      ref: "Mo_modal_success",
      onModalclosed: _cache[7] || (_cache[7] = ($event: any) => (_ctx.get()))
    }, {
      title: _withCtx(() => [
        _hoisted_45,
        _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.message4ModalSuccess), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_47
      ]),
      footer: _withCtx(() => [
        _hoisted_48
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _hoisted_49,
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_50
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("button", {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Or_map, {
      ref: "Or_map",
      lat: _ctx.mapLat,
      "onUpdate:lat": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.mapLat) = $event)),
      lng: _ctx.mapLng,
      "onUpdate:lng": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.mapLng) = $event))
    }, null, 8, ["lat", "lng"])
  ]))
}